import {ConstraintsBuilder} from './constraints-builder';

const Factory = {
    getBuilder: () => ConstraintsBuilder,
};

export {Factory};
